<template>
  <v-form :submit="submitUpdate">
    <v-row>
      <v-col cols="4">
        <AutocompleteSelectCashier v-model="cashierFrom" />
      </v-col>
      <v-col cols="4">
        <AutocompleteSelectCashier v-model="cashierTo" />
      </v-col>
      <v-col cols="4">
        <v-text-field
          label="Valor R$"
          v-model="amount"
          type="number"
          density="compact"
          hide-details
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field
          label="Descrição"
          v-model="description"
          density="compact"
          hide-details
        ></v-text-field>
      </v-col>
      <v-col cols="12" class="text-right">
        <v-btn color="success" type="submit"
          ><v-icon class="mr-2">mdi-content-save</v-icon> Transferir</v-btn
        >
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import AutocompleteSelectCashier from "./AutocompleteSelectCashier.vue";
import api from '@/services'
export default {
  components: { AutocompleteSelectCashier },
  props: {
    user: Object,
  },
  data() {
    return {
      requestingApi: null,
      cashierFrom: null,
      cashierTo: null,
      amount: null,
      description: null,
    };
  },
  created() {},
  mounted() {},
  methods: {
    submitUpdate() {
      var vm = this;
      vm.requestingApi = true;
      return new Promise((resolve, reject) => {
        api.cashierTransfer
          .create({
            cashier_from: vm.cashierFrom,
            cashier_to: vm.cashierTo,
            amount: vm.amount,
            description: vm.description,
          })
          .then((result) => {
            vm.cashierFrom = null
            vm.cashierTo = null
            vm.amount = null
            vm.description = null
            vm.$emit("created", result);
            vm.$notify({
              type: "success",
              text: "Transferência concluída",
            });
          })
          .catch((err) => {
            if (err.message) {
              vm.$notify({
                type: "warn",
                text: err.message,
              });
            }
          })
          .finally(() => {
            vm.requestingApi = false;
          });
      });
    },
  },
  computed: {},
  watch: {},
};
</script>